export default "__VITE_ASSET__dIDVJvYy__"